import { render, staticRenderFns } from "./dictionarymenu.vue?vue&type=template&id=1c6460be&scoped=true&"
import script from "./dictionarymenu.vue?vue&type=script&lang=js&"
export * from "./dictionarymenu.vue?vue&type=script&lang=js&"
import style0 from "./dictionarymenu.vue?vue&type=style&index=0&id=1c6460be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6460be",
  null
  
)

export default component.exports